module.exports = __webpack_public_path__ + "static/media/Germanaising-tile.8774d3cf.jpg";